import { z } from 'zod';
import { BaseProductDTO, ShippingMethodDTO } from '../types';

const BaseBasketDTO = z.object({
    id: z.string(),
    productsCount: z.number(),
    samplesCount: z.number(),
    totalBeforeDiscount: z.number().optional(),
    shippingTotal: z.number().optional(),
    currency: z.string(), // FIXME: should be optional
    total: z.number().optional(),
    totalDiscount: z.number().optional(),
    shipments: z
        .array(
            z.object({
                shippingMethod: z
                    .object({
                        id: z.string().optional(),
                        description: z.string().optional(),
                        name: z.string().optional(),
                        groupId: ShippingMethodDTO.optional(),
                        gtmName: z.string().optional(),
                        price: z.number().optional(),
                    })
                    .optional(),
            }),
        )
        .optional(),
});

const EngraveDTO = z.object({
    font: z.string().optional(),
    line1: z.string().optional(),
    line2: z.string().optional(),
    line3: z.string().optional(),
});

export const CustomerBasketContainerDTO = BaseBasketDTO.extend({
    products: z.array(z.unknown()).default([]),
});

export const CustomerBasketProductDTO = BaseProductDTO.extend({
    imageURL: z.string().optional(),
    productId: z.string(),
    shadeId: z.number().optional(),
    quantity: z.number(),
    maxQuantity: z.number().optional(), // FIXME: should be optional ??
    salesPrice: z.number().optional(),
    isPreOrderable: z.boolean().optional(),
    releaseDate: z.string().datetime().optional(),
    isBonus: z.boolean().default(false),
    promotion: z.union([z.literal('STANDARD'), z.literal('OMNIBUS'), z.literal('REGULAR')]).optional(),
    pricePerUnit: z.string().optional(),
    engraves: z.array(EngraveDTO).optional(),
});

export const CustomerBasketDTO = BaseBasketDTO.extend({
    products: z.array(CustomerBasketProductDTO).default([]),
});

export type CustomerBasketDTO = z.infer<typeof CustomerBasketDTO>;
